// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ArticleCard = require('client-v2/common/components/cards/article')
const PromoBadge = require('client-v2/common/containers/promo-badge/component-smart')
// Sibling imports
const TopCallToActionCollectionCard = require('./collection-card')

const bem = BemEntity('TopCallToActionSplitTrailing')

function TopCallToActionSplitTrailing(props) {
  return tag('div', {
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('item', 'collection')
    },
      tag(TopCallToActionCollectionCard, {
        className: bem.element('card', 'collection'),
        // Values
        collection: props.collection,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onFollowClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('caption', 'collection')
      },
        `Discover the most interesting things\n`,
        `your friends are sharing`
      )
    ),

    tag('div', {
      className: bem.element('item', 'article')
    },
      tag(ArticleCard, {
        className: bem.element('card', 'article'),
        // Flags
        isHrefsEnabled: false,
        // Values
        article: props.article,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onAddClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('caption', 'article')
      },
        `Share your favorite websites,\n`,
        `articles, photos, and videos`
      ),
      props.showPromos && tag('div', {
        className: bem.element('promo-container')
      },
        tag(PromoBadge, {
          className: bem.element('promo-badge'),
          id: 'ios'
        }),
        tag(PromoBadge, {
          className: bem.element('promo-badge'),
          id: 'android'
        }),
        tag('br'),
        tag(PromoBadge, {
          className: bem.element('promo-badge')
        })
      )
    )
  )
}

module.exports = TopCallToActionSplitTrailing
